// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * CMS dialogs — PrimeReact portals to document.body (outside .cms-mfe-root).
 * Overall scale is 20% smaller via --cms-mfe-dialog-scale (0.8).
 */

.p-dialog.cms-mfe-dialog {
  --cms-mfe-dialog-scale: 0.9;
  --cms-mfe-dialog-input-height: calc(1.875rem * var(--cms-mfe-dialog-scale));
  zoom: var(--cms-mfe-dialog-scale);
  border-radius: var(--cms-mfe-radius-lg);
  overflow: hidden;
  box-shadow: var(--cms-mfe-shadow-md);
  font-size: var(--cms-mfe-font-size-sm);
}

@supports not (zoom: 1) {
  .p-dialog.cms-mfe-dialog {
    transform: scale(var(--cms-mfe-dialog-scale));
    transform-origin: center center;
  }
}

.p-dialog.cms-mfe-dialog .p-dialog-header {
  border-bottom: 1px solid var(--cms-mfe-color-border);
  padding: var(--cms-mfe-space-md) var(--cms-mfe-space-lg);
  font-weight: 600;
  font-size: var(--cms-mfe-font-size);
}

.p-dialog.cms-mfe-dialog .p-dialog-content {
  padding: var(--cms-mfe-space-lg);
}

.p-dialog.cms-mfe-dialog .p-dialog-footer {
  padding: var(--cms-mfe-space-md) var(--cms-mfe-space-lg);
  gap: var(--cms-mfe-space-sm);
}

.p-dialog.cms-mfe-dialog .cms-mfe-dialog-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  margin-top: var(--cms-mfe-space-md);
  padding-top: var(--cms-mfe-space-sm);
  border-top: 1px solid var(--cms-mfe-color-border);
  gap: var(--cms-mfe-space-sm);
}

.p-dialog.cms-mfe-dialog .cms-mfe-dialog-footer .p-button {
  height: 2rem;
  min-height: 2rem;
  padding: 0.3125rem 0.75rem;
  font-size: var(--cms-mfe-font-size-sm);
}

.p-dialog.cms-mfe-dialog .cms-mfe-dialog-footer .p-button .p-button-icon {
  font-size: 0.8125rem;
}

.p-dialog.cms-mfe-dialog .cms-mfe-dialog-footer .p-button:last-child {
  margin-left: auto;
}

/* ── Dialog chrome ───────────────────────────────────────────── */

.p-dialog.cms-mfe-dialog .cms-dialog-header {
  margin: 0 0 var(--cms-mfe-space-md);
  padding: 0.375rem 0.625rem;
  border-left: 3px solid var(--cms-mfe-color-primary);
  background: var(--cms-mfe-color-primary-soft);
  border-radius: var(--cms-mfe-radius-sm);
  color: var(--cms-mfe-color-text);
  font-weight: 600;
  font-size: var(--cms-mfe-font-size-xs);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  line-height: 1.35;
}

.p-dialog.cms-mfe-dialog .cms-dialog-body {
  max-height: min(80vh, 720px);
  overflow-y: auto;
  padding-right: 0.125rem;
}

.p-dialog.cms-mfe-dialog .cms-dialog-form {
  font-size: var(--cms-mfe-font-size-sm);
}

.p-dialog.cms-mfe-dialog .cms-form-pair-grid {
  row-gap: 0;
  margin-bottom: var(--cms-mfe-space-sm);
}

.p-dialog.cms-mfe-dialog .cms-form-pair__label-col,
.p-dialog.cms-mfe-dialog .cms-form-pair__value-col {
  min-width: 0;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
}

.p-dialog.cms-mfe-dialog .cms-form-pair__label {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  min-height: var(--cms-mfe-dialog-input-height);
  padding: 0.25rem 0.5rem;
  line-height: 1.3;
  border: 1px solid var(--cms-mfe-color-border);
  background: var(--cms-mfe-color-surface-muted);
  color: var(--cms-mfe-color-text-muted);
  font-size: var(--cms-mfe-font-size-xs);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  border-radius: var(--cms-mfe-radius-sm) 0 0 var(--cms-mfe-radius-sm);
  border-right: none;
  margin: 0;
}

.p-dialog.cms-mfe-dialog .cms-form-pair__required {
  color: var(--cms-mfe-color-danger);
  font-weight: 700;
}

.p-dialog.cms-mfe-dialog .cms-form-pair__control {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 1 auto;
  min-height: var(--cms-mfe-dialog-input-height);
  padding: 0.1875rem 0.375rem;
  border: 1px solid var(--cms-mfe-color-border);
  background: var(--cms-mfe-color-surface-elevated);
  border-radius: 0 var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm) 0;
  min-width: 0;
}

.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-inputtext,
.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-inputnumber-input,
.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-dropdown,
.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-multiselect,
.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-calendar,
.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-inputnumber {
  height: calc(var(--cms-mfe-dialog-input-height) - 0.375rem);
  min-height: calc(var(--cms-mfe-dialog-input-height) - 0.375rem);
  font-size: var(--cms-mfe-font-size-sm);
  width: 100%;
  border: none;
  background: transparent;
  box-shadow: none;
}

.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-dropdown .p-dropdown-label,
.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-multiselect .p-multiselect-label {
  padding-top: 0.1875rem;
  padding-bottom: 0.1875rem;
  font-size: var(--cms-mfe-font-size-sm);
}

.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-dropdown .p-dropdown-trigger,
.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-multiselect .p-multiselect-trigger {
  width: calc(var(--cms-mfe-dialog-input-height) - 0.375rem);
}

.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-inputtextarea {
  min-height: calc(var(--cms-mfe-dialog-input-height) * 1.5);
  padding: 0.25rem 0.375rem;
  font-size: var(--cms-mfe-font-size-sm);
  border: none;
  background: transparent;
  box-shadow: none;
}

.p-dialog.cms-mfe-dialog .cms-form-pair__error {
  display: block;
  margin: 0.125rem 0 0.375rem;
  padding-left: 0.125rem;
  font-size: var(--cms-mfe-font-size-xs);
  line-height: 1.25;
}

/* ── Detail pairs (OutPutPair) inside dialogs ────────────────── */

.p-dialog.cms-mfe-dialog .cms-output-pair__label-col,
.p-dialog.cms-mfe-dialog .cms-output-pair__value-col {
  min-width: 0;
  margin-bottom: 0;
}

.p-dialog.cms-mfe-dialog .cms-output-pair__label,
.p-dialog.cms-mfe-dialog .cms-output-pair__value {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  min-height: 1.625rem;
  padding: 0.25rem 0.5rem;
  line-height: 1.3;
  border: 1px solid var(--cms-mfe-color-border);
  min-width: 0;
}

.p-dialog.cms-mfe-dialog .cms-output-pair__label {
  height: 100%;
  background: var(--cms-mfe-color-surface-muted);
  color: var(--cms-mfe-color-text-muted);
  font-size: var(--cms-mfe-font-size-xs);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  border-radius: var(--cms-mfe-radius-sm) 0 0 var(--cms-mfe-radius-sm);
  border-right: none;
}

.p-dialog.cms-mfe-dialog .cms-output-pair__value {
  height: 100%;
  background: var(--cms-mfe-color-surface-elevated);
  color: var(--cms-mfe-color-text);
  font-size: var(--cms-mfe-font-size-sm);
  word-break: break-word;
  border-radius: 0 var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm) 0;
}

.p-dialog.cms-mfe-dialog .cms-output-pair__value--empty {
  color: var(--cms-mfe-color-text-muted);
}

.p-dialog.cms-mfe-dialog .cms-output-pair__value--custom {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.p-dialog.cms-mfe-dialog .p-field > label,
.p-dialog.cms-mfe-dialog label {
  display: block;
  margin-bottom: var(--cms-mfe-space-xs);
  font-size: var(--cms-mfe-font-size-sm);
  font-weight: 500;
  color: var(--cms-mfe-color-text-muted);
}

@media (max-width: 767px) {
  .p-dialog.cms-mfe-dialog .cms-form-pair__label {
    border-right: 1px solid var(--cms-mfe-color-border);
    border-radius: var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm) 0 0;
    border-bottom: none;
  }

  .p-dialog.cms-mfe-dialog .cms-form-pair__control {
    border-radius: 0 0 var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm);
    margin-bottom: var(--cms-mfe-space-xs);
  }

  .p-dialog.cms-mfe-dialog .cms-output-pair__label {
    border-right: 1px solid var(--cms-mfe-color-border);
    border-radius: var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm) 0 0;
    border-bottom: none;
  }

  .p-dialog.cms-mfe-dialog .cms-output-pair__value {
    border-left: 1px solid var(--cms-mfe-color-border);
    border-radius: 0 0 var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm);
    margin-bottom: var(--cms-mfe-space-sm);
  }
}
`, "",{"version":3,"sources":["webpack://./src/cms/cms-dialog.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,2BAA2B;EAC3B,2EAA2E;EAC3E,iCAAiC;EACjC,uCAAuC;EACvC,gBAAgB;EAChB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE;IACE,6CAA6C;IAC7C,+BAA+B;EACjC;AACF;;AAEA;EACE,oDAAoD;EACpD,wDAAwD;EACxD,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wDAAwD;EACxD,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,mCAAmC;EACnC,oCAAoC;EACpC,iDAAiD;EACjD,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mEAAmE;;AAEnE;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,mDAAmD;EACnD,6CAA6C;EAC7C,uCAAuC;EACvC,gCAAgC;EAChC,gBAAgB;EAChB,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,sCAAsC;AACxC;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,8CAA8C;EAC9C,uBAAuB;EACvB,gBAAgB;EAChB,6CAA6C;EAC7C,8CAA8C;EAC9C,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oEAAoE;EACpE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,8CAA8C;EAC9C,2BAA2B;EAC3B,6CAA6C;EAC7C,iDAAiD;EACjD,oEAAoE;EACpE,YAAY;AACd;;AAEA;;;;;;EAME,2DAA2D;EAC3D,+DAA+D;EAC/D,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;;EAEE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;EAC1D,yBAAyB;EACzB,sCAAsC;EACtC,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,sBAAsB;EACtB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA,mEAAmE;;AAEnE;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,8CAA8C;EAC9C,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oEAAoE;EACpE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iDAAiD;EACjD,gCAAgC;EAChC,sCAAsC;EACtC,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;EACd,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE;IACE,mDAAmD;IACnD,oEAAoE;IACpE,mBAAmB;EACrB;;EAEA;IACE,oEAAoE;IACpE,sCAAsC;EACxC;;EAEA;IACE,mDAAmD;IACnD,oEAAoE;IACpE,mBAAmB;EACrB;;EAEA;IACE,kDAAkD;IAClD,oEAAoE;IACpE,sCAAsC;EACxC;AACF","sourcesContent":["/**\r\n * CMS dialogs — PrimeReact portals to document.body (outside .cms-mfe-root).\r\n * Overall scale is 20% smaller via --cms-mfe-dialog-scale (0.8).\r\n */\r\n\r\n.p-dialog.cms-mfe-dialog {\r\n  --cms-mfe-dialog-scale: 0.9;\r\n  --cms-mfe-dialog-input-height: calc(1.875rem * var(--cms-mfe-dialog-scale));\r\n  zoom: var(--cms-mfe-dialog-scale);\r\n  border-radius: var(--cms-mfe-radius-lg);\r\n  overflow: hidden;\r\n  box-shadow: var(--cms-mfe-shadow-md);\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n}\r\n\r\n@supports not (zoom: 1) {\r\n  .p-dialog.cms-mfe-dialog {\r\n    transform: scale(var(--cms-mfe-dialog-scale));\r\n    transform-origin: center center;\r\n  }\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .p-dialog-header {\r\n  border-bottom: 1px solid var(--cms-mfe-color-border);\r\n  padding: var(--cms-mfe-space-md) var(--cms-mfe-space-lg);\r\n  font-weight: 600;\r\n  font-size: var(--cms-mfe-font-size);\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .p-dialog-content {\r\n  padding: var(--cms-mfe-space-lg);\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .p-dialog-footer {\r\n  padding: var(--cms-mfe-space-md) var(--cms-mfe-space-lg);\r\n  gap: var(--cms-mfe-space-sm);\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-mfe-dialog-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  margin-top: var(--cms-mfe-space-md);\r\n  padding-top: var(--cms-mfe-space-sm);\r\n  border-top: 1px solid var(--cms-mfe-color-border);\r\n  gap: var(--cms-mfe-space-sm);\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-mfe-dialog-footer .p-button {\r\n  height: 2rem;\r\n  min-height: 2rem;\r\n  padding: 0.3125rem 0.75rem;\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-mfe-dialog-footer .p-button .p-button-icon {\r\n  font-size: 0.8125rem;\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-mfe-dialog-footer .p-button:last-child {\r\n  margin-left: auto;\r\n}\r\n\r\n/* ── Dialog chrome ───────────────────────────────────────────── */\r\n\r\n.p-dialog.cms-mfe-dialog .cms-dialog-header {\r\n  margin: 0 0 var(--cms-mfe-space-md);\r\n  padding: 0.375rem 0.625rem;\r\n  border-left: 3px solid var(--cms-mfe-color-primary);\r\n  background: var(--cms-mfe-color-primary-soft);\r\n  border-radius: var(--cms-mfe-radius-sm);\r\n  color: var(--cms-mfe-color-text);\r\n  font-weight: 600;\r\n  font-size: var(--cms-mfe-font-size-xs);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  line-height: 1.35;\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-dialog-body {\r\n  max-height: min(80vh, 720px);\r\n  overflow-y: auto;\r\n  padding-right: 0.125rem;\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-dialog-form {\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-form-pair-grid {\r\n  row-gap: 0;\r\n  margin-bottom: var(--cms-mfe-space-sm);\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__label-col,\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__value-col {\r\n  min-width: 0;\r\n  margin-bottom: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__label {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  align-items: center;\r\n  flex: 1 1 auto;\r\n  min-height: var(--cms-mfe-dialog-input-height);\r\n  padding: 0.25rem 0.5rem;\r\n  line-height: 1.3;\r\n  border: 1px solid var(--cms-mfe-color-border);\r\n  background: var(--cms-mfe-color-surface-muted);\r\n  color: var(--cms-mfe-color-text-muted);\r\n  font-size: var(--cms-mfe-font-size-xs);\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  border-radius: var(--cms-mfe-radius-sm) 0 0 var(--cms-mfe-radius-sm);\r\n  border-right: none;\r\n  margin: 0;\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__required {\r\n  color: var(--cms-mfe-color-danger);\r\n  font-weight: 700;\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__control {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  flex: 1 1 auto;\r\n  min-height: var(--cms-mfe-dialog-input-height);\r\n  padding: 0.1875rem 0.375rem;\r\n  border: 1px solid var(--cms-mfe-color-border);\r\n  background: var(--cms-mfe-color-surface-elevated);\r\n  border-radius: 0 var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm) 0;\r\n  min-width: 0;\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-inputtext,\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-inputnumber-input,\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-dropdown,\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-multiselect,\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-calendar,\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-inputnumber {\r\n  height: calc(var(--cms-mfe-dialog-input-height) - 0.375rem);\r\n  min-height: calc(var(--cms-mfe-dialog-input-height) - 0.375rem);\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n  width: 100%;\r\n  border: none;\r\n  background: transparent;\r\n  box-shadow: none;\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-dropdown .p-dropdown-label,\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-multiselect .p-multiselect-label {\r\n  padding-top: 0.1875rem;\r\n  padding-bottom: 0.1875rem;\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-dropdown .p-dropdown-trigger,\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-multiselect .p-multiselect-trigger {\r\n  width: calc(var(--cms-mfe-dialog-input-height) - 0.375rem);\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__control .p-inputtextarea {\r\n  min-height: calc(var(--cms-mfe-dialog-input-height) * 1.5);\r\n  padding: 0.25rem 0.375rem;\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n  border: none;\r\n  background: transparent;\r\n  box-shadow: none;\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-form-pair__error {\r\n  display: block;\r\n  margin: 0.125rem 0 0.375rem;\r\n  padding-left: 0.125rem;\r\n  font-size: var(--cms-mfe-font-size-xs);\r\n  line-height: 1.25;\r\n}\r\n\r\n/* ── Detail pairs (OutPutPair) inside dialogs ────────────────── */\r\n\r\n.p-dialog.cms-mfe-dialog .cms-output-pair__label-col,\r\n.p-dialog.cms-mfe-dialog .cms-output-pair__value-col {\r\n  min-width: 0;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-output-pair__label,\r\n.p-dialog.cms-mfe-dialog .cms-output-pair__value {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: 1.625rem;\r\n  padding: 0.25rem 0.5rem;\r\n  line-height: 1.3;\r\n  border: 1px solid var(--cms-mfe-color-border);\r\n  min-width: 0;\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-output-pair__label {\r\n  height: 100%;\r\n  background: var(--cms-mfe-color-surface-muted);\r\n  color: var(--cms-mfe-color-text-muted);\r\n  font-size: var(--cms-mfe-font-size-xs);\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  border-radius: var(--cms-mfe-radius-sm) 0 0 var(--cms-mfe-radius-sm);\r\n  border-right: none;\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-output-pair__value {\r\n  height: 100%;\r\n  background: var(--cms-mfe-color-surface-elevated);\r\n  color: var(--cms-mfe-color-text);\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n  word-break: break-word;\r\n  border-radius: 0 var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm) 0;\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-output-pair__value--empty {\r\n  color: var(--cms-mfe-color-text-muted);\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .cms-output-pair__value--custom {\r\n  padding-top: 0.125rem;\r\n  padding-bottom: 0.125rem;\r\n}\r\n\r\n.p-dialog.cms-mfe-dialog .p-field > label,\r\n.p-dialog.cms-mfe-dialog label {\r\n  display: block;\r\n  margin-bottom: var(--cms-mfe-space-xs);\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n  font-weight: 500;\r\n  color: var(--cms-mfe-color-text-muted);\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .p-dialog.cms-mfe-dialog .cms-form-pair__label {\r\n    border-right: 1px solid var(--cms-mfe-color-border);\r\n    border-radius: var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm) 0 0;\r\n    border-bottom: none;\r\n  }\r\n\r\n  .p-dialog.cms-mfe-dialog .cms-form-pair__control {\r\n    border-radius: 0 0 var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm);\r\n    margin-bottom: var(--cms-mfe-space-xs);\r\n  }\r\n\r\n  .p-dialog.cms-mfe-dialog .cms-output-pair__label {\r\n    border-right: 1px solid var(--cms-mfe-color-border);\r\n    border-radius: var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm) 0 0;\r\n    border-bottom: none;\r\n  }\r\n\r\n  .p-dialog.cms-mfe-dialog .cms-output-pair__value {\r\n    border-left: 1px solid var(--cms-mfe-color-border);\r\n    border-radius: 0 0 var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm);\r\n    margin-bottom: var(--cms-mfe-space-sm);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
